import React, { useState } from "react";
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";
import Orders from "./Orders";

const OpsDashboard = () => {
  const [activeTab, setActiveTab] = useState("orders");

  const renderTabContent = () => {
    switch (activeTab) {
      case "orders":
        return <Orders />;
    }
  };

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#eef2f6" }}>
      <Container className="p-4 w-100" style={{ maxWidth: "100%" }}>
        <Row className="mb-4">
          <Col>
            <h3 className="fw-bold">
              Ops Dashboard
            </h3>
          </Col>
        </Row>

        <Nav className="mb-2 pb-2">
          {[
            { key: "orders", label: "Orders", icon: "fas fa-cart-shopping" },
          ].map(({ key, label, icon }) => (
            <NavItem key={key}>
              <NavLink
                onClick={() => setActiveTab(key)}
                className={`px-3 py-2 fw-semibold me-3 ${
                  activeTab === key
                    ? "text-primary border-bottom border-2 border-primary"
                    : "text-dark"
                }`}
                style={{
                  backgroundColor: "transparent",
                  fontSize: "1rem",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <i className={`${icon} me-2`}></i>
                {label}
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        {renderTabContent()}
      </Container>
    </div>
  );
};

export default OpsDashboard;
